import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { PopoverRef } from '../popover/popover-ref';

@Component({
  selector: 'vex-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  constructor(private readonly popoverRef: PopoverRef, private auth: AuthService) { }

  ngOnInit(): void {
  }

  close(): void {
    /** Wait for animation to complete and then close */
    setTimeout(() => this.popoverRef.close(), 250);
  }

  logout(): void{
    this.auth.logoutUser();
    this.popoverRef.close();
    window.location.assign('login');
  }
}
